import React,{useState,useEffect,useCallback}from'react';
import{useNavigate,useParams}from'react-router-dom';
import Layout from'../components/layout/Layout';
import api from'../services/api';

const SECTION=({title,children}:any)=>(
  <div className="bg-white rounded-xl shadow-sm border p-5 mb-4">
    <h3 className="font-bold text-gray-800 text-base mb-4 pb-2 border-b">{title}</h3>
    {children}
  </div>
);
const FLD=({label,required,children}:any)=>(
  <div><label className="block text-sm font-medium text-gray-700 mb-1">{label}{required&&<span className="text-red-500 ml-1">*</span>}</label>{children}</div>
);
const INP=({value,onChange,type='text',placeholder='',className=''}:any)=>(
  <input type={type} value={value} onChange={onChange} placeholder={placeholder} className={`w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#015CA6] focus:border-transparent outline-none ${className}`}/>
);
const SEL=({value,onChange,children}:any)=>(
  <select value={value} onChange={onChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#015CA6] outline-none bg-white">{children}</select>
);
const TXT=({value,onChange,placeholder='',rows=2}:any)=>(
  <textarea value={value} onChange={onChange} rows={rows} placeholder={placeholder} className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-[#015CA6] outline-none"/>
);
const CHK=({checked,onChange,label,color=''}:any)=>(
  <label className="flex items-center gap-2 cursor-pointer">
    <input type="checkbox" checked={checked} onChange={onChange} className="w-4 h-4 rounded"/>
    <span className={`text-sm font-medium ${color}`}>{label}</span>
  </label>
);

export default function PatientRegistrationPage(){
  const nav=useNavigate();
  const {id}=useParams();
  const isEdit=!!id;
  const [loading,setLoading]=useState(false);
  const [saving,setSaving]=useState(false);
  const [msg,setMsg]=useState('');
  const [error,setError]=useState('');

  const [form,setForm]=useState({
    // Identity
    firstName:'',middleName:'',lastName:'',
    dateOfBirth:'',gender:'',bloodGroup:'',
    maritalStatus:'',religion:'',nationality:'Indian',
    occupation:'',education:'',
    // Contact — frontend uses 'mobile', backend maps to 'phone'
    mobile:'',alternatePhone:'',email:'',
    // Address
    addressLine1:'',addressLine2:'',
    city:'',district:'',state:'',postalCode:'',country:'India',
    // Emergency contact — maps to emergencyContactName/Phone/Relation/Address
    emergencyContactName:'',emergencyContactPhone:'',
    emergencyContactRelation:'',emergencyContactAddress:'',
    // Identity docs — entity: aadhaarNumber, panNumber, passportNumber, drivingLicenseNumber, voterIdNumber
    aadhaarNumber:'',panNumber:'',passportNumber:'',drivingLicenseNumber:'',voterIdNumber:'',abhaNumber:'',
    // Insurance — entity: insuranceId, insuranceProvider, insurancePolicyNumber, insuranceExpiry
    insuranceId:'',insuranceProvider:'',insurancePolicyNumber:'',insuranceExpiry:'',
    // Govt schemes — entity: pmjayBeneficiaryId, shaBeneficiaryId, schemeName
    pmjayBeneficiaryId:'',shaBeneficiaryId:'',schemeName:'',
    // Family — entity: fatherName, motherName, spouseName
    fatherName:'',motherName:'',spouseName:'',
    // Clinical — entity: knownAllergies, drugAllergy, foodAllergy, chronicConditions, smokingStatus, alcoholStatus, tobaccoUsage
    knownAllergies:'',drugAllergy:'',foodAllergy:'',otherAllergy:'',
    chronicConditions:'',
    smokingStatus:'NEVER',alcoholStatus:'NEVER',tobaccoUsage:'NONE',
    hasDiabetes:false,hasHypertension:false,hasAsthma:false,hasHeartDisease:false,hasCancer:false,
    // ABDM — entity: abhaAddress, abhaLinkedMobile
    abhaAddress:'',abhaLinkedMobile:'',
    // Other
    referredBy:'',employerName:'',
    preferredLanguage:'Hindi',
    profileImage:'',
    crmId:'',
    isActive:true,
    patientType:'GENERAL',
    isVIP:false,isMLCPatient:false,
    requiresInterpreter:false,
  });

  const f=(k:string,v:any)=>setForm(x=>({...x,[k]:v}));

  const load=useCallback(async()=>{
    if(!isEdit){setLoading(false);return;}
    setLoading(true);
    try{
      const r=await api.getPatientById?.(id!).catch(()=>({data:null}));
      if(r?.data){
        const p=r.data;
        setForm(prev=>({...prev,
          firstName:p.firstName||p.first_name||'',
          middleName:p.middleName||p.middle_name||'',
          lastName:p.lastName||p.last_name||'',
          dateOfBirth:p.dateOfBirth?.split('T')[0]||p.date_of_birth?.split('T')[0]||'',
          gender:p.gender||'',
          bloodGroup:p.bloodGroup||p.blood_group||'',
          maritalStatus:p.maritalStatus||p.marital_status||'',
          religion:p.religion||'',
          nationality:p.nationality||'Indian',
          occupation:p.occupation||'',
          education:p.education||'',
          // phone maps back to mobile
          mobile:p.phone||p.mobile||'',
          alternatePhone:p.alternatePhone||p.alternate_phone||'',
          email:p.email||'',
          addressLine1:p.addressLine1||p.address_line1||'',
          addressLine2:p.addressLine2||p.address_line2||'',
          city:p.city||'',district:p.district||'',
          state:p.state||'',postalCode:p.postalCode||p.postal_code||'',
          country:p.country||'India',
          emergencyContactName:p.emergencyContactName||p.emergency_contact_name||'',
          emergencyContactPhone:p.emergencyContactPhone||p.emergency_contact_phone||'',
          emergencyContactRelation:p.emergencyContactRelation||p.emergency_contact_relation||'',
          emergencyContactAddress:p.emergencyContactAddress||p.emergency_contact_address||'',
          aadhaarNumber:p.aadhaarNumber||p.aadhaar_number||'',
          panNumber:p.panNumber||p.pan_number||'',
          passportNumber:p.passportNumber||p.passport_number||'',
          drivingLicenseNumber:p.drivingLicenseNumber||p.driving_license_number||'',
          voterIdNumber:p.voterIdNumber||p.voter_id_number||'',
          abhaNumber:p.abhaNumber||p.abha_number||'',
          abhaAddress:p.abhaAddress||p.abha_address||'',
          abhaLinkedMobile:p.abhaLinkedMobile||p.abha_linked_mobile||'',
          insuranceId:p.insuranceId||p.insurance_id||'',
          insuranceProvider:p.insuranceProvider||p.insurance_provider||'',
          insurancePolicyNumber:p.insurancePolicyNumber||p.insurance_policy_number||'',
          insuranceExpiry:p.insuranceExpiry?.split('T')[0]||p.insurance_expiry?.split('T')[0]||'',
          pmjayBeneficiaryId:p.pmjayBeneficiaryId||p.pmjay_beneficiary_id||'',
          shaBeneficiaryId:p.shaBeneficiaryId||p.sha_beneficiary_id||'',
          schemeName:p.schemeName||p.scheme_name||'',
          fatherName:p.fatherName||p.father_name||'',
          motherName:p.motherName||p.mother_name||'',
          spouseName:p.spouseName||p.spouse_name||'',
          knownAllergies:p.knownAllergies||p.known_allergies||'',
          drugAllergy:p.drugAllergy||p.drug_allergy||'',
          foodAllergy:p.foodAllergy||p.food_allergy||'',
          otherAllergy:p.otherAllergy||p.other_allergy||'',
          chronicConditions:p.chronicConditions||p.chronic_conditions||'',
          smokingStatus:p.smokingStatus||p.smoking_status||'NEVER',
          alcoholStatus:p.alcoholStatus||p.alcohol_status||'NEVER',
          tobaccoUsage:p.tobaccoUsage||p.tobacco_usage||'NONE',
          hasDiabetes:p.hasDiabetes||p.has_diabetes||false,
          hasHypertension:p.hasHypertension||p.has_hypertension||false,
          hasAsthma:p.hasAsthma||p.has_asthma||false,
          hasHeartDisease:p.hasHeartDisease||p.has_heart_disease||false,
          hasCancer:p.hasCancer||p.has_cancer||false,
          referredBy:p.referredBy||p.referred_by||'',
          employerName:p.employerName||p.employer_name||'',
          preferredLanguage:p.preferredLanguage||p.preferred_language||'Hindi',
          profileImage:p.profileImage||p.profile_image||'',
          crmId:p.crmId||p.crm_id||'',
          isVIP:p.isVIP||p.is_vip||false,
        }));
      }
    }catch{}
    setLoading(false);
  },[id,isEdit]);

  useEffect(()=>{load();},[load]);

  const submit=async()=>{
    if(!form.firstName||!form.lastName||!form.mobile||!form.gender){
      setError('First name, last name, mobile and gender are required');return;
    }
    setSaving(true);setError('');
    try{
      const payload={
        // Identity
        firstName:form.firstName,middleName:form.middleName||null,lastName:form.lastName,
        dateOfBirth:form.dateOfBirth||null,gender:form.gender,
        bloodGroup:form.bloodGroup||null,maritalStatus:form.maritalStatus||null,
        religion:form.religion||null,nationality:form.nationality||'Indian',
        occupation:form.occupation||null,education:form.education||null,
        // Contact — CRITICAL: send as 'phone' to match entity column
        phone:form.mobile,                          // entity column is 'phone'
        mobile:form.mobile,                         // also send mobile for backward compat
        alternatePhone:form.alternatePhone||null,
        email:form.email||null,
        // Address
        addressLine1:form.addressLine1||null,addressLine2:form.addressLine2||null,
        city:form.city||null,district:form.district||null,
        state:form.state||null,postalCode:form.postalCode||null,country:form.country||'India',
        // Emergency
        emergencyContactName:form.emergencyContactName||null,
        emergencyContactPhone:form.emergencyContactPhone||null,
        emergencyContactRelation:form.emergencyContactRelation||null,
        emergencyContactAddress:form.emergencyContactAddress||null,
        // Docs
        aadhaarNumber:form.aadhaarNumber||null,
        panNumber:form.panNumber||null,
        passportNumber:form.passportNumber||null,
        drivingLicenseNumber:form.drivingLicenseNumber||null,
        voterIdNumber:form.voterIdNumber||null,
        abhaNumber:form.abhaNumber||null,
        abhaAddress:form.abhaAddress||null,
        abhaLinkedMobile:form.abhaLinkedMobile||null,
        crmId:form.crmId||null,
        // Insurance
        insuranceId:form.insuranceId||null,
        insuranceProvider:form.insuranceProvider||null,
        insurancePolicyNumber:form.insurancePolicyNumber||null,
        insuranceExpiry:form.insuranceExpiry||null,
        pmjayBeneficiaryId:form.pmjayBeneficiaryId||null,
        shaBeneficiaryId:form.shaBeneficiaryId||null,
        schemeName:form.schemeName||null,
        // Family
        fatherName:form.fatherName||null,
        motherName:form.motherName||null,
        spouseName:form.spouseName||null,
        // Clinical
        knownAllergies:form.knownAllergies||null,
        drugAllergy:form.drugAllergy||null,
        foodAllergy:form.foodAllergy||null,
        otherAllergy:form.otherAllergy||null,
        chronicConditions:form.chronicConditions||null,
        smokingStatus:form.smokingStatus||null,
        alcoholStatus:form.alcoholStatus||null,
        tobaccoUsage:form.tobaccoUsage||null,
        hasDiabetes:form.hasDiabetes,hasHypertension:form.hasHypertension,
        hasAsthma:form.hasAsthma,hasHeartDisease:form.hasHeartDisease,hasCancer:form.hasCancer,
        // Other
        referredBy:form.referredBy||null,
        employerName:form.employerName||null,
        preferredLanguage:form.preferredLanguage||null,
        profileImage:form.profileImage||null,
        isActive:true,
        branchId: localStorage.getItem('activeBranchId') || localStorage.getItem('locationId') || localStorage.getItem('branchId') || null,
        stationId: localStorage.getItem('stationId') || null,
      };
      if (!payload.branchId) { setError('Select a location at login before registering a patient'); setSaving(false); return; }
      if(isEdit){
        await api.updatePatient?.(id!,payload);
        setMsg('✅ Patient updated successfully');
        setTimeout(()=>nav('/patients'),1500);
      }else{
        const r=await api.createPatient?.(payload);
        const uhid=r?.data?.uhid||r?.data?.data?.uhid||'Generated';
        setMsg(`✅ Patient registered! UHID: ${uhid}`);
        setTimeout(()=>nav('/patients'),2000);
      }
    }catch(e:any){
      const msg=e?.response?.data?.message||e?.message||'Registration failed';
      setError('❌ '+msg);
    }
    setSaving(false);
  };

  if(loading)return<Layout><div className="flex items-center justify-center h-64 text-gray-400">Loading patient data...</div></Layout>;

  return(
    <Layout>
      <div className="p-6 max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{isEdit?'Edit Patient':'New Patient Registration'}</h1>
            <p className="text-gray-500 text-sm mt-1">{isEdit?'Update patient information':'Register a new patient and generate UHID'}</p>
            <p className="text-sm text-[#02357A] mt-1">Location: {localStorage.getItem('locationName') || localStorage.getItem('branchName') || 'Not selected'} · Workstation: {localStorage.getItem('stationName') || 'Not selected'}</p>
          </div>
          <button onClick={()=>nav('/patients')} className="border px-4 py-2 rounded-lg hover:bg-gray-50 text-sm text-gray-600">← Back</button>
        </div>

        {error&&<div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg text-sm">{error}</div>}
        {msg&&<div className="mb-4 p-3 bg-green-50 border border-green-200 text-green-700 rounded-lg text-sm font-semibold">{msg}</div>}

        {/* Patient Type */}
        <SECTION title="Patient Type & Category">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            <FLD label="Patient Type"><SEL value={form.patientType} onChange={(e:any)=>f('patientType',e.target.value)}>
              {['GENERAL','BPL','CGHS','ESI','AYUSHMAN','CORPORATE','VIP','STAFF','FOREIGNER'].map(t=><option key={t}>{t}</option>)}
            </SEL></FLD>
            <FLD label="Preferred Language"><SEL value={form.preferredLanguage} onChange={(e:any)=>f('preferredLanguage',e.target.value)}>
              {['Hindi','English','Bhojpuri','Maithili','Urdu','Bengali','Tamil','Telugu','Marathi','Gujarati'].map(l=><option key={l}>{l}</option>)}
            </SEL></FLD>
            <div className="flex flex-col gap-2 pt-5">
              <CHK checked={form.isVIP} onChange={(e:any)=>f('isVIP',e.target.checked)} label="VIP Patient"/>
              <CHK checked={form.requiresInterpreter} onChange={(e:any)=>f('requiresInterpreter',e.target.checked)} label="Requires Interpreter"/>
              <CHK checked={form.isMLCPatient} onChange={(e:any)=>f('isMLCPatient',e.target.checked)} label="MLC Case" color="text-red-600"/>
            </div>
          </div>
        </SECTION>

        {/* Basic Info */}
        <SECTION title="Basic Information">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <FLD label="First Name" required><INP value={form.firstName} onChange={(e:any)=>f('firstName',e.target.value)} placeholder="First name"/></FLD>
            <FLD label="Middle Name"><INP value={form.middleName} onChange={(e:any)=>f('middleName',e.target.value)} placeholder="Middle name"/></FLD>
            <FLD label="Last Name" required><INP value={form.lastName} onChange={(e:any)=>f('lastName',e.target.value)} placeholder="Last name"/></FLD>
            <FLD label="CRM ID"><INP value={form.crmId} onChange={(e:any)=>f('crmId',e.target.value.toUpperCase())} placeholder="Auto if blank — CRM2026000001"/></FLD>
            <FLD label="Date of Birth"><INP type="date" value={form.dateOfBirth} onChange={(e:any)=>f('dateOfBirth',e.target.value)}/></FLD>
            <FLD label="Gender" required><SEL value={form.gender} onChange={(e:any)=>f('gender',e.target.value)}>
              <option value="">Select Gender</option>
              {['MALE','FEMALE','TRANSGENDER','OTHER'].map(g=><option key={g}>{g}</option>)}
            </SEL></FLD>
            <FLD label="Blood Group"><SEL value={form.bloodGroup} onChange={(e:any)=>f('bloodGroup',e.target.value)}>
              <option value="">Unknown</option>
              {['A+','A-','B+','B-','AB+','AB-','O+','O-'].map(g=><option key={g}>{g}</option>)}
            </SEL></FLD>
            <FLD label="Marital Status"><SEL value={form.maritalStatus} onChange={(e:any)=>f('maritalStatus',e.target.value)}>
              <option value="">Select</option>
              {['SINGLE','MARRIED','DIVORCED','WIDOWED','SEPARATED'].map(s=><option key={s}>{s}</option>)}
            </SEL></FLD>
            <FLD label="Religion"><SEL value={form.religion} onChange={(e:any)=>f('religion',e.target.value)}>
              <option value="">Select</option>
              {['HINDU','MUSLIM','CHRISTIAN','SIKH','BUDDHIST','JAIN','OTHER'].map(r=><option key={r}>{r}</option>)}
            </SEL></FLD>
            <FLD label="Nationality"><INP value={form.nationality} onChange={(e:any)=>f('nationality',e.target.value)} placeholder="Indian"/></FLD>
            <FLD label="Occupation"><INP value={form.occupation} onChange={(e:any)=>f('occupation',e.target.value)} placeholder="Job/Profession"/></FLD>
            <FLD label="Education"><SEL value={form.education} onChange={(e:any)=>f('education',e.target.value)}>
              <option value="">Select</option>
              {['ILLITERATE','PRIMARY','SECONDARY','SENIOR_SECONDARY','GRADUATE','POST_GRADUATE','PROFESSIONAL','OTHER'].map(e=><option key={e}>{e}</option>)}
            </SEL></FLD>
            <FLD label="Employer"><INP value={form.employerName} onChange={(e:any)=>f('employerName',e.target.value)} placeholder="Company / employer name"/></FLD>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
            <FLD label="Father's Name"><INP value={form.fatherName} onChange={(e:any)=>f('fatherName',e.target.value)} placeholder="Father's full name"/></FLD>
            <FLD label="Mother's Name"><INP value={form.motherName} onChange={(e:any)=>f('motherName',e.target.value)} placeholder="Mother's name"/></FLD>
            <FLD label="Spouse Name"><INP value={form.spouseName} onChange={(e:any)=>f('spouseName',e.target.value)} placeholder="Husband / Wife name"/></FLD>
          </div>
        </SECTION>

        {/* Contact */}
        <SECTION title="Contact Information">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <FLD label="Mobile Number" required><INP value={form.mobile} onChange={(e:any)=>f('mobile',e.target.value)} placeholder="10-digit mobile number"/></FLD>
            <FLD label="Alternate Phone"><INP value={form.alternatePhone} onChange={(e:any)=>f('alternatePhone',e.target.value)} placeholder="Alternate number"/></FLD>
            <FLD label="Email Address"><INP type="email" value={form.email} onChange={(e:any)=>f('email',e.target.value)} placeholder="patient@email.com"/></FLD>
          </div>
        </SECTION>

        {/* Address */}
        <SECTION title="Address Details">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="md:col-span-3"><FLD label="Address Line 1"><INP value={form.addressLine1} onChange={(e:any)=>f('addressLine1',e.target.value)} placeholder="House no., Street, Area"/></FLD></div>
            <div className="md:col-span-3"><FLD label="Address Line 2"><INP value={form.addressLine2} onChange={(e:any)=>f('addressLine2',e.target.value)} placeholder="Landmark, Locality (optional)"/></FLD></div>
            <FLD label="City"><INP value={form.city} onChange={(e:any)=>f('city',e.target.value)} placeholder="City"/></FLD>
            <FLD label="District"><INP value={form.district} onChange={(e:any)=>f('district',e.target.value)} placeholder="District"/></FLD>
            <FLD label="State"><SEL value={form.state} onChange={(e:any)=>f('state',e.target.value)}>
              <option value="">Select State</option>
              {['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Delhi','Jammu & Kashmir','Ladakh'].map(s=><option key={s}>{s}</option>)}
            </SEL></FLD>
            <FLD label="PIN Code"><INP value={form.postalCode} onChange={(e:any)=>f('postalCode',e.target.value)} placeholder="6-digit PIN"/></FLD>
            <FLD label="Country"><INP value={form.country} onChange={(e:any)=>f('country',e.target.value)} placeholder="India"/></FLD>
          </div>
        </SECTION>

        {/* Emergency Contact */}
        <SECTION title="Emergency Contact">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <FLD label="Contact Name"><INP value={form.emergencyContactName} onChange={(e:any)=>f('emergencyContactName',e.target.value)} placeholder="Full name"/></FLD>
            <FLD label="Contact Phone"><INP value={form.emergencyContactPhone} onChange={(e:any)=>f('emergencyContactPhone',e.target.value)} placeholder="Mobile number"/></FLD>
            <FLD label="Relation"><SEL value={form.emergencyContactRelation} onChange={(e:any)=>f('emergencyContactRelation',e.target.value)}>
              <option value="">Select Relation</option>
              {['SPOUSE','FATHER','MOTHER','SON','DAUGHTER','SIBLING','FRIEND','GUARDIAN','OTHER'].map(r=><option key={r}>{r}</option>)}
            </SEL></FLD>
            <div className="md:col-span-3"><FLD label="Contact Address"><INP value={form.emergencyContactAddress} onChange={(e:any)=>f('emergencyContactAddress',e.target.value)} placeholder="Emergency contact address"/></FLD></div>
          </div>
        </SECTION>

        {/* Identity Documents */}
        <SECTION title="Identity Documents">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <FLD label="Aadhaar Number"><INP value={form.aadhaarNumber} onChange={(e:any)=>f('aadhaarNumber',e.target.value)} placeholder="XXXX-XXXX-XXXX"/></FLD>
            <FLD label="PAN Number"><INP value={form.panNumber} onChange={(e:any)=>f('panNumber',e.target.value)} placeholder="ABCDE1234F"/></FLD>
            <FLD label="Passport Number"><INP value={form.passportNumber} onChange={(e:any)=>f('passportNumber',e.target.value)} placeholder="Passport number"/></FLD>
            <FLD label="Driving License"><INP value={form.drivingLicenseNumber} onChange={(e:any)=>f('drivingLicenseNumber',e.target.value)} placeholder="DL number"/></FLD>
            <FLD label="Voter ID"><INP value={form.voterIdNumber} onChange={(e:any)=>f('voterIdNumber',e.target.value)} placeholder="Voter ID number"/></FLD>
          </div>
        </SECTION>

        {/* ABDM / ABHA */}
        <SECTION title="ABDM / ABHA Details">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <FLD label="ABHA Number"><INP value={form.abhaNumber} onChange={(e:any)=>f('abhaNumber',e.target.value)} placeholder="14-digit ABHA number"/></FLD>
            <FLD label="ABHA Address"><INP value={form.abhaAddress} onChange={(e:any)=>f('abhaAddress',e.target.value)} placeholder="username@abdm"/></FLD>
            <FLD label="ABHA Linked Mobile"><INP value={form.abhaLinkedMobile} onChange={(e:any)=>f('abhaLinkedMobile',e.target.value)} placeholder="Mobile linked to ABHA"/></FLD>
          </div>
        </SECTION>

        {/* Government Schemes */}
        <SECTION title="Government Schemes">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <FLD label="Ayushman / PM-JAY ID"><INP value={form.pmjayBeneficiaryId} onChange={(e:any)=>f('pmjayBeneficiaryId',e.target.value)} placeholder="PM-JAY beneficiary ID"/></FLD>
            <FLD label="SHA / State Scheme ID"><INP value={form.shaBeneficiaryId} onChange={(e:any)=>f('shaBeneficiaryId',e.target.value)} placeholder="State health scheme ID"/></FLD>
            <FLD label="Scheme Name"><INP value={form.schemeName} onChange={(e:any)=>f('schemeName',e.target.value)} placeholder="CGHS, ESI, Mukhyamantri..."/></FLD>
          </div>
        </SECTION>

        {/* Insurance */}
        <SECTION title="Insurance Details">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <FLD label="Insurance Provider"><INP value={form.insuranceProvider} onChange={(e:any)=>f('insuranceProvider',e.target.value)} placeholder="Star Health, HDFC Ergo…"/></FLD>
            <FLD label="Policy Number"><INP value={form.insurancePolicyNumber} onChange={(e:any)=>f('insurancePolicyNumber',e.target.value)} placeholder="Policy number"/></FLD>
            <FLD label="TPA / Insurance ID"><INP value={form.insuranceId} onChange={(e:any)=>f('insuranceId',e.target.value)} placeholder="TPA member ID"/></FLD>
            <FLD label="Policy Expiry"><INP type="date" value={form.insuranceExpiry} onChange={(e:any)=>f('insuranceExpiry',e.target.value)}/></FLD>
          </div>
        </SECTION>

        {/* Medical Background */}
        <SECTION title="Medical Background">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <FLD label="Smoking Status"><SEL value={form.smokingStatus} onChange={(e:any)=>f('smokingStatus',e.target.value)}>
              {['NEVER','FORMER','CURRENT'].map(s=><option key={s}>{s}</option>)}
            </SEL></FLD>
            <FLD label="Alcohol Status"><SEL value={form.alcoholStatus} onChange={(e:any)=>f('alcoholStatus',e.target.value)}>
              {['NEVER','OCCASIONAL','REGULAR'].map(s=><option key={s}>{s}</option>)}
            </SEL></FLD>
            <FLD label="Tobacco Usage"><SEL value={form.tobaccoUsage} onChange={(e:any)=>f('tobaccoUsage',e.target.value)}>
              {['NONE','OCCASIONAL','REGULAR'].map(s=><option key={s}>{s}</option>)}
            </SEL></FLD>
          </div>
          <div className="flex flex-wrap gap-4 mb-4">
            {[['hasDiabetes','Diabetes'],['hasHypertension','Hypertension'],['hasAsthma','Asthma'],['hasHeartDisease','Heart Disease'],['hasCancer','Cancer']].map(([k,l])=>(
              <CHK key={k} checked={(form as any)[k]} onChange={(e:any)=>f(k,e.target.checked)} label={l}/>
            ))}
          </div>
          <div className="grid grid-cols-1 gap-4">
            <FLD label="Known Allergies (combined)"><TXT value={form.knownAllergies} onChange={(e:any)=>f('knownAllergies',e.target.value)} placeholder="All allergies summary"/></FLD>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <FLD label="Drug Allergies"><TXT value={form.drugAllergy} onChange={(e:any)=>f('drugAllergy',e.target.value)} placeholder="Penicillin, Aspirin…" rows={2}/></FLD>
              <FLD label="Food Allergies"><TXT value={form.foodAllergy} onChange={(e:any)=>f('foodAllergy',e.target.value)} placeholder="Peanuts, Shellfish…" rows={2}/></FLD>
              <FLD label="Other Allergies"><TXT value={form.otherAllergy} onChange={(e:any)=>f('otherAllergy',e.target.value)} placeholder="Latex, Dust…" rows={2}/></FLD>
            </div>
            <FLD label="Chronic Conditions"><TXT value={form.chronicConditions} onChange={(e:any)=>f('chronicConditions',e.target.value)} placeholder="Diabetes, Hypertension, Asthma, Heart disease…"/></FLD>
          </div>
        </SECTION>

        {/* Referral */}
        <SECTION title="Referral Information">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FLD label="Referred By"><INP value={form.referredBy} onChange={(e:any)=>f('referredBy',e.target.value)} placeholder="Doctor name or source"/></FLD>
          </div>
        </SECTION>

        {/* Submit */}
        <div className="flex gap-3 justify-end mt-6 pb-8">
          <button onClick={()=>nav('/patients')} className="px-6 py-2.5 border rounded-xl hover:bg-gray-50 text-gray-700">Cancel</button>
          <button onClick={submit} disabled={saving} className="px-8 py-2.5 bg-[#02357A] text-white rounded-xl hover:bg-[#015CA6] font-semibold disabled:opacity-50 min-w-40">
            {saving?'Saving…':(isEdit?'Update Patient':'Register Patient')}
          </button>
        </div>
      </div>
    </Layout>
  );
}
